import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.setupStickyNavbar();
    this.setupMobileMenu();
    this.setupResizeHandler();
  }

  setupStickyNavbar() {
    const navbar = document.getElementById('navbar');
    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        navbar.style.backgroundColor = 'rgb(255, 255, 255)';
        navbar.classList.add('shadow-md');
      } else {
        navbar.style.backgroundColor = 'transparent';
        navbar.classList.remove('shadow-md');
      }
    });
  }

  setupMobileMenu() {
    this.mobileMenuButton = document.getElementById('mobile-menu-button');
    this.mobileMenu = document.getElementById('mobile-menu');
    this.isMenuOpen = false;
    
    this.mobileMenuButton.addEventListener('click', () => {
      this.toggleMobileMenu();
    });
  }

  toggleMobileMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    
    if (this.isMenuOpen) {
      this.mobileMenu.style.maxHeight = this.mobileMenu.scrollHeight + 'px';
      // Change hamburger to X icon
      this.mobileMenuButton.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      `;
    } else {
      this.mobileMenu.style.maxHeight = '0';
      // Change X to hamburger icon
      this.mobileMenuButton.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      `;
    }
  }

  setupResizeHandler() {
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 1024 && this.isMenuOpen) { // lg breakpoint
        this.mobileMenu.style.maxHeight = '0';
        this.isMenuOpen = false;
        this.mobileMenuButton.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        `;
      }
    });
  }
} 